//#region src/group_ordering_name_type.ts
var GroupOrderingNameType = /* @__PURE__ */ function(GroupOrderingNameType) {
	GroupOrderingNameType["Name"] = "name";
	GroupOrderingNameType["Number"] = "number";
	return GroupOrderingNameType;
}(GroupOrderingNameType || {});
//#endregion
export { GroupOrderingNameType };

//# sourceMappingURL=group_ordering_name_type.js.map